export const toastsZIndex = 2147483647;
export const animationDuration = 500;
export const defaultToastShowTime = 5000;
export const defaultReleaseToastTime = 1000;
export const smallScreenWidth = 768;
